import React from 'react';
import './ProfileBanner.css'
const ProfileBanner = () => {
    return (
        <div className='profile-banner-container'>
            <div className="profile-banner">
                <img src={require('../../../images/offer/offer-main.jpg')} className='h-100 w-100' alt="" />
                <div className="profile-banner-text">
                    <h1>Profile</h1>
                </div>
            </div>
        </div>
    );
};

export default ProfileBanner;